import React from 'react'
import useImport from '../../import'
import InfoNote from '../../InfoNote'

const resultMap = {
  entities: 'categories in storefront',
  updated: 'categories updated',
  created: 'categories created',
  deleted: false,
  validated: false,
}

const CategoriesImport = () => {
  const { FileSelector, FileImport, result, fileSelected, disabled } =
    useImport({
      event: 'Categories import',
      method: 'categories/import',
      resultMap,
    })

  return (
    <>
      {!result?.runId && !fileSelected && (
        <>
          <FileSelector disabled={disabled} />

          <div className="rounded-md opacity-70 mt-auto pt-4">
            <InfoNote title="Storefront WARNING">
              Storefront selected for download does not affect this import.{' '}
              <span className="text-red-700">
                The file you import will make changes to your
                categories--affecting whatever trees and storefronts are
                associated with the categories.
              </span>
            </InfoNote>
            <InfoNote title="Won't delete">
              Import process <em>will not</em>&nbsp;delete any categories.{' '}
            </InfoNote>
            <InfoNote title="Have a backup?">
              Make sure you have a{' '}
              <span className="font-bold">recent, unmodified CSV file</span> in
              case you need to restore your data.{' '}
            </InfoNote>
          </div>
        </>
      )}

      {(result?.runId || fileSelected) && <FileImport />}
    </>
  )
}

export default CategoriesImport
